export const environment = {
  production: false,
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfig: {

  apiKey: "AIzaSyDYQk2MMZoWql4clI-vl5q-Mq6h3DZPGu4",
  authDomain: "lenalikoura.firebaseapp.com",
  projectId: "lenalikoura",
  storageBucket: "lenalikoura.firebasestorage.app",
  messagingSenderId: "2799810244",
  appId: "1:2799810244:web:19833756a76b36289b7b91",
  measurementId: "G-BEND45370S"
},
}


